<template>
  <div class="product-detail">
    <div class="info-item title">Bind Product</div>
    <div class="info-item">Submission Time：{{ infoObj.localCreateTime }}</div>
    <div class="info-item">Audit Result：<span :style="`color: ${infoObj.statusColor}`">{{ infoObj.statusText }}</span></div>
    <div class="info-item">Bind Product {{ infoObj.totalQuantity }} PCS，earned {{ infoObj.totalIntegral }} points。</div>
    <div class="info-item" v-if="infoObj.detailList && infoObj.detailList.length > 0">
      <div>Product Details：</div>
      <div v-for="(subItem, subIndex) in infoObj.detailList" :key="subItem.id" class="code-item">SN{{ subIndex + 1 }}：{{ subItem.snCode }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    infoObj: {
      type: Object,
      default: () => {}
    }
  }
}
</script>

<style lang="less" scoped>
.product-detail {
  padding: 28px 23px;
  font-size: 13px;
  color: #333;
  .info-item {
    padding: 6px 0;
  }
  .title {
    font-weight: bold;
  }
  .code-item {
    padding: 12px 10px;
    background-color: #f2f2f2;
    margin-bottom: 5px;
    &:nth-child(2) {
      margin-top: 6px;
    }
  }
}
</style>
